import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBedModel } from '../models/tBedModel';
import { tEmployeeModel, tEmployeeWithTypeModel, DefaultEmployeeTypeListModel, tEmployeeModelV2,DefaultEmployeeTypeListModelV2 } from '../models/tEmployeeModel';
import { EmployeeLeaveModel } from '../models/EmployeeLeaveModel';



@Injectable({
    providedIn: 'root'
})

export class tEmployeeService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tEmployee';

    readonly Path_tEmployee = this.baseurl + this.pathName;

    getAllData() {
        return this.http.get<tEmployeeModel[]>(this.baseurl + this.pathName);
    }

    getAllDataWithEmployeeType() {
        return this.http.get<tEmployeeWithTypeModel[]>(this.baseurl + this.pathName + '/WithtEmployeeTypeInfo');
    }

    getAlltEmployeeWithTypeInfo() {
        return this.http.get<tEmployeeWithTypeModel[]>(this.baseurl + this.pathName + '/getAlltEmployeeWithTypeInfo');
    }

    getEmployeeByIDWithTypeInfo(employeeID: number,shopID:string) {
        return this.http.get<EmployeeLeaveModel[]>(this.baseurl + this.pathName + '/getEmployeeByIDWithTypeInfo'+ '/'+ employeeID+"/"+shopID);
    }

    getAllDataWithEmployeeType_diagonsis() {
        return this.http.get<tEmployeeWithTypeModel[]>(this.baseurl + this.pathName + '/WithtEmployeeTypeInfoDiagonsis');
    }

    getAllDataOnlyTherapist() {
      return this.http.get<tEmployeeWithTypeModel[]>(this.baseurl + this.pathName + '/WithtEmployeeTypeTherapist');
  }

    getDataById(shopID: number, employeeID: string) {
        return this.http.get<tEmployeeModel>(this.baseurl + this.pathName + '/' + shopID + '/' + employeeID);
    }

    getDataByIdV2(shopID: number, employeeID: string){
      return this.http.get<tEmployeeModelV2>(this.baseurl + this.pathName + '/' + shopID + '/' + employeeID);
    }

    getEmployeeTypeList(shopID: number, etypeID: number) {
        // return this.http.get<DefaultEmployeeTypeListModel>(this.baseurl + this.pathName + '/GetEmployeeTypeList/'+ shopID + '/'+ etypeID);
        return this.http.get<DefaultEmployeeTypeListModel>(this.baseurl + this.pathName + '/doctors/'+ shopID);
    }
    getEmployeeTypeListCopyPres(shopID: number, etypeID: number) {
      //return this.http.get<DefaultEmployeeTypeListModel>(this.baseurl + this.pathName + '/GetEmployeeTypeList/'+ shopID + '/'+ etypeID);
      return this.http.get<DefaultEmployeeTypeListModel>(this.baseurl + this.pathName + '/doctors2/'+ shopID);
  }
  GetDoctorsTransHistory(shopID: number, etypeID: number) {
    //return this.http.get<DefaultEmployeeTypeListModel>(this.baseurl + this.pathName + '/GetEmployeeTypeList/'+ shopID + '/'+ etypeID);
    return this.http.get<DefaultEmployeeTypeListModelV2>(this.baseurl + this.pathName + '/doctors3/'+ shopID);
}
    addData(data: tEmployeeModel) {
        return this.http.post(this.baseurl + this.pathName + '/Formatted/', data);
        // return this.http.post(this.baseurl + this.pathName, data);
    }

    deleteData(data: tEmployeeModel) {
        return this.http.delete(this.baseurl + this.pathName + '/Formatted/' + data.shopID + '/' + data.employeeID);
    }

    // deleteData(data: tEmployeeModel) {
    //     return this.http.delete(this.baseurl + this.pathName + '/' + data.shopID+ '/'+ data.employeeID);
    // }

    updateData(data: tEmployeeModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/' + data.shopID + '/' + data.employeeID, data);
    }

    getDoctors(){
      return this.http.get<Doctor[]>(this.baseurl + this.pathName + '/doctors');
    }

    viewEmpIconURL(employeeID:string):string{
      return `${this.Path_tEmployee}/empIcon/${employeeID}`;
    }

    //upload icon
    uploadEmpIcon(employeeID:string , data:FormData){
      return this.http.put(`${this.Path_tEmployee}/empIcon/${employeeID}`,data);
    }

    //remove icon
    removeEmpIcon(employeeID:string){
      return this.http.delete(`${this.Path_tEmployee}/empIcon/${employeeID}`);
    }
}

export class Doctor{
  employeeID:string;
  employeeChiName:string;
  employeeRemark1:string;
  inActive:string;
}
